module.exports = __webpack_public_path__ + "static/media/aceshades-logo.d9e16ad4.png";